import { createApp } from 'vue'
import Average from './Average.vue'
import './assets/global.css'

createApp(Average).mount('#average')
